import styled from 'styled-components';

import { CommonPluginContainer } from './CommonPluginContainer';

export const GameContainer = styled(CommonPluginContainer)`
  position: relative;
  width: 100%;
  padding: 0;
  box-sizing: border-box;
  text-align: center;
`;
GameContainer.displayName = 'GameContainer';

export const GamePatternImage = styled.img`
  width: 100%;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
`;
GamePatternImage.displayName = 'GamePatternImage';

export const VideoElement = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
`;
VideoElement.displayName = 'VideoElement';

export const WinVideoElement = styled(VideoElement)`
  display: block;
`;
WinVideoElement.displayName = 'WinVideoElement';

export const LoseVideoElement = styled(VideoElement)`
  display: block;
`;
LoseVideoElement.displayName = 'LoseVideoElement';

export const LandingVideoElement = styled(VideoElement)`
  display: block;
`;
LandingVideoElement.displayName = 'LandingVideoElement';

export const PatternImage = styled.img`
  width: 100%;
`;
PatternImage.displayName = 'PatternImage';

export const LoadingText = styled.div`
  position: absolute;
  top: 25vh;
  left: 0;
  right: 0;
  text-align: center;
  font-size: 3vh;
  color: black;
`;
LoadingText.displayName = 'LoadingText';

